import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  border: ${({ highlightedBoxShadowColor }) =>
    highlightedBoxShadowColor ? '1px solid var(--blue)' : 0};
  border-radius: ${({ reverse }) => (reverse ? '10px 10px 20px 20px' : '20px 20px 10px 10px')};
  box-shadow: ${({ highlightedBoxShadowColor }) =>
    highlightedBoxShadowColor ? 'none' : '0 0 0 1px var(--border-color) inset'};
  background-color: var(--white);
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'column-reverse' : 'column')};

  button {
    ${({ highlightedBoxShadowColor }) =>
      highlightedBoxShadowColor ? 'border: 0; border-radius: 8px;' : ''};
  }
`;

const Text = styled.div`
  padding: 15px 30px;
  text-align: center;
  color: var(--text-color);

  > p {
    margin: 0 0 12.5px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const RoundedInfoWrapper = ({ children, info, reverse, highlightedBoxShadowColor }) => (
  <Wrapper reverse={reverse} highlightedBoxShadowColor={highlightedBoxShadowColor}>
    <Text>{info}</Text>
    {children}
  </Wrapper>
);

RoundedInfoWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  info: PropTypes.node.isRequired,
  reverse: PropTypes.bool,
  highlightedBoxShadowColor: PropTypes.bool,
};

RoundedInfoWrapper.defaultProps = {
  reverse: false,
  highlightedBoxShadowColor: false,
};
